import axios from 'axios';

const basicAuth = async({username, password, loginPath}) => {
  try {
    const authorizationHeader = `Basic ${btoa(`${username}:${password}`)}`;

    const response = await axios.post(loginPath, {
      headers: { Authorization: authorizationHeader }
    });

    if (response.status === 200) {
      return true;
    }
    return false;
  } catch(e) {
    return false;
  }
}

export default basicAuth;
